module.exports = (__webpack_require__(6))(791);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/semantic-ui-react/dist/commonjs/collections/Table/index.js from dll-reference vendor_library
// module id = 46
// module chunks = 0